import { BigQueryForm } from '@/components/admin/data-sources/BigQueryForm';
import { PageHeader } from '@/components/layout/PageHeader';
import { PageShell } from '@/components/layout/PageShell';
import { ApiError, api } from '@/lib/api';
import type { CreateDataSourceRequest } from '@innermate/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useState } from 'react';

export function AdminDataSourceNewBigQuery() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [serverError, setServerError] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: (body: CreateDataSourceRequest) => api.dataSourceCreate(body),
    onSuccess: (created) => {
      qc.invalidateQueries({ queryKey: ['admin', 'data-sources'] });
      navigate({ to: '/admin/data-sources/$id', params: { id: created.id } });
    },
    onError: (err: unknown) => {
      setServerError(err instanceof ApiError ? err.message : '등록에 실패했습니다.');
    },
  });

  return (
    <PageShell
      header={
        <>
          <button
            type="button"
            onClick={() => navigate({ to: '/admin/data-sources' })}
            className="mb-4 inline-flex items-center gap-1 text-xs text-foreground-muted hover:text-foreground"
          >
            <ArrowLeft className="size-3.5" />
            데이터 소스 목록
          </button>
          <PageHeader
            title="BigQuery 데이터소스 추가"
            description="GCP 서비스계정 키(JSON)로 연결합니다. 등록하면 데이터셋/테이블 구조가 자동 동기화되고, 챗에서 SQL 로 탐색·질의할 수 있습니다."
          />
        </>
      }
    >
      <div className="max-w-2xl">
        {serverError ? (
          <div
            role="alert"
            className="mb-4 rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm text-destructive"
          >
            {serverError}
          </div>
        ) : null}

        <BigQueryForm
          submitLabel="BigQuery 등록"
          submitting={mutation.isPending}
          onSubmit={(body) => {
            setServerError(null);
            mutation.mutate(body);
          }}
          onCancel={() => navigate({ to: '/admin/data-sources' })}
        />
      </div>
    </PageShell>
  );
}
